/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CloudSearchResponse } from '../../models/cloud-search-response';

export interface MediaControllerCloudSearch$Params {
  keyword: string;
  limit?: number;
  skip?: number;
}

export function mediaControllerCloudSearch(http: HttpClient, rootUrl: string, params: MediaControllerCloudSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CloudSearchResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, mediaControllerCloudSearch.PATH, 'get');
  if (params) {
    rb.query('keyword', params.keyword, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CloudSearchResponse;
      }>;
    })
  );
}

mediaControllerCloudSearch.PATH = '/multimedia/unsplash/find';
